<template>
    <Modal :show-modal="$store?.modals.reportModal || false" @cancel="closeModal">
        <template v-slot:header>
            <p class="text-3xl font-bold text-main-color">{{ $t('page.report') }}</p>
        </template>
        <template v-slot:content>
            <div class="flex flex-col">
                <Form @submit="postReport" :validation-schema="reportPublicationSchema()">
                <div class="w-full flex flex-col gap-2">
                    <label for="report_type" class="text-start font-semibold text-main-color">{{ $t('form.reportType')
                        }}</label>
                    <Field v-model="formReport.report_type" as="select" name="report_type" id="report_type"
                        class="w-full rounded flex border justify-between px-8 py-5 placeholder-[#5F5F5F] max-md:py-4">
                        <option selected disabled>{{ $t('page.selectValue') }}</option>
                        <template v-if="this.$store.reportTypes.length > 0">

                            <option v-for="report in this.$store.reportTypes" :value="report.id" :key="report.id">{{ report.name }}
                            </option>

                        </template>
                    </Field>
                    <ErrorMessage name="report_type" class="text-red-500"></ErrorMessage>
                </div>
                <div class="mt-5 flex flex-col gap-2">
                    <label for="content" class="text-start font-semibold text-main-color">{{ $t('form.message')
                        }}</label>
                    <Field v-model="formReport.content" as="textarea" name="content" id="content" cols="30" rows="4"
                        class="w-full rounded border px-8 py-5 placeholder-[#5F5F5F] resize-none max-md:py-4">
                    </Field>
                    <ErrorMessage name="content" class="text-red-500"></ErrorMessage>

                </div>
                <div class="flex flex-col my-6">
                    <div class="flex gap-2">
                        <Field type="checkbox" class="w-6 h-6" name="terms" id="terms" value="off"></Field>
                        <label class="text-start" for="terms">
                            <router-link class="text-accent-color hover:text-main-color" :to="{ name: 'policy' }">
                                {{ $t('page.reportTerms') }}
                            </router-link>
                        </label>
                    </div>
                    <ErrorMessage name="terms" class="text-red-500"></ErrorMessage>
                </div>
                <div class="mt-5 flex gap-5">
                    <SubmitBtn type="submit" :loading="loading">{{ $t('action.send') }}</SubmitBtn>
                    <button @click="closeModal" class="w-full text-main-color font-bold">{{ $t('action.cancel') }}</button>
                </div>
            </Form>
            </div>

        </template>
    </Modal>
</template>


<script>
import api from '@/api';
import { i18n } from '@/i18n'
import { reportPublicationSchema } from '@/schemas'
import { Field, Form, ErrorMessage } from 'vee-validate';
import Modal from '@cmp/Modal.vue'

export default{
    components: {
        Modal,
        Field, 
        Form, 
        ErrorMessage
    },
    props: {
        itemId: null,
        origin: 'product',

    },
    data(){
        return { 
            loading: false,
            formReport: {
                content: '',
                report_type: ''
            },
            reportPublicationSchema: reportPublicationSchema,
            reportOriginUrls: {
                'mallStore': 'mall/stores/',
                'businessAccount': 'posts/business_accounts/',
                'product': 'mall/products/',
                'exhibition': 'exhibition/products/',
                'exhibitionStore': 'exhibition/stores/',
                'publication': 'publications/publications/'
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.modals.reportModal = false
        },
        async postReport() {
            this.loading = true
            try {
                const response = await api.post(`${this.reportOriginUrls[this.origin]}${this.itemId}/report/`, this.formReport)
                this.$toast.info(`${i18n.global.t('warning.PUBLICATION_REPORTED')}`)
                
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },

    }
}
</script>